"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CROP_FIELD = exports.HOTSPOT_FIELD = exports.ASSET_FIELD = void 0;
var ASSET_FIELD = {
  name: 'asset',
  type: 'reference',
  to: [{
    type: 'sanity.imageAsset'
  }]
};
exports.ASSET_FIELD = ASSET_FIELD;
var HOTSPOT_FIELD = {
  name: 'hotspot',
  type: 'sanity.imageHotspot'
};
exports.HOTSPOT_FIELD = HOTSPOT_FIELD;
var CROP_FIELD = {
  name: 'crop',
  type: 'sanity.imageCrop'
};
exports.CROP_FIELD = CROP_FIELD;